
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'call': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M3.62 7.79a15.149 15.149 0 0 0 6.59 6.59l2.2-2.2a.994.994 0 0 1 1.02-.24 11.407 11.407 0 0 0 3.57.57 1 1 0 0 1 1 1V17a1 1 0 0 1-1 1A17 17 0 0 1 0 1a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.57 1 1 0 0 1-.25 1.02l-2.2 2.2z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
